import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]
  static values = { duration: { type: Number, default: 300 } }

  connect() {
    this.isOpen = false
  }

  open() {
    if (this.isOpen) return

    const overlay = this.overlayElement
    const panel = this.panelElement
    if (!overlay || !panel) return

    this.isOpen = true
    overlay.classList.remove("hidden")
    panel.classList.remove("hidden")
    document.documentElement.classList.add("overflow-hidden")

    requestAnimationFrame(() => {
      overlay.classList.remove("opacity-0")
      panel.classList.remove("opacity-0", "translate-y-8")
    })
  }

  close() {
    if (!this.isOpen) return

    const overlay = this.overlayElement
    const panel = this.panelElement
    if (!overlay || !panel) {
      this.isOpen = false
      document.documentElement.classList.remove("overflow-hidden")
      return
    }

    this.isOpen = false
    overlay.classList.add("opacity-0")
    panel.classList.add("opacity-0", "translate-y-8")

    window.setTimeout(() => {
      if (this.isOpen) return

      overlay.classList.add("hidden")
      panel.classList.add("hidden")
    }, this.durationValue)

    document.documentElement.classList.remove("overflow-hidden")
  }

  get overlayElement() {
    if (this.hasOverlayTarget) return this.overlayTarget

    return this.element.querySelector('[data-cart-sidebar-target="overlay"]')
  }

  get panelElement() {
    if (this.hasPanelTarget) return this.panelTarget

    return this.element.querySelector('[data-cart-sidebar-target="panel"]')
  }
}
